(function () {
  'use strict';

  /* ==========================================================================
     OFFRE DE NOVEMBRE : LE BANDEAU          Casemira 28/10/2026 (offre de novembre)
     --------------------------------------------------------------------------
     Sous l'offre (`sections/topbar.liquid` rend `[data-cm-haut]`), ce fichier
     ne fait plus tourner les trois messages et n'intercepte plus le lien de la
     pop-up newsletter (il n'est pas rendu). Il :
       1. ouvre la fenêtre d'explication au clic sur le bandeau
          (window.CM_OFFRE_FENETRE, assets/casemira-offre-fenetre.js) ;
       2. réécrit les montants rendus par Liquid pour la période de REPLI
          (la page sort du cache) avec ceux de la période du jour,
          window.CM_OFFRE : `data-cm-montant="1..4"`, `data-cm-seuil="1..4"`,
          `data-cm-montant-max`, `data-cm-pct`, dans toute la section (bandeau
          ET fenêtre), au chargement puis à chaque passage de minuit
          (`cm-offre-periode`) ; bascule `cm-hors-euro` sur les `[data-cm-hors-euro]` ;
       3. tient `--casemira-topbar-h` = hauteur de la section (calcul
          d'origine : plus de barre du jour à soustraire, retours 3 du 28/10) ;
       4. écrit la date courte des pastilles d'événement
          (`[data-cm-date-courte]`, snippets/casemira-offre-pastille.liquid) dans
          la langue de la page : « 26 nov. », « 26 Nov », « 26. Nov. ».
     Aucun texte face client ici.
     ========================================================================== */
  function chaque(liste, fn) {
    for (var i = 0; i < liste.length; i++) fn(liste[i]);
  }

  function echappe(t) {
    return String(t).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  /* « 20 € » -> « 20<small>€</small> » (marches de la fenêtre, maquette). */
  function deviseEnPetit(f) {
    var m = /^(\D*?)(\d(?:[\d.,'\s]*\d)?)(\D*)$/.exec(f);
    if (!m) return echappe(f);
    var avant = m[1].trim();
    var apres = m[3].trim();
    /* 31/10 : « 20€ » reste collé (symbole), mais une unité en lettres (kr, Kč,
       Ft, lei, hors euro) prend une espace fine insécable : « 1 775 kr ». */
    var sep = /^[A-Za-z\u00C0-\u024F]/.test(apres) ? '\u202f' : '';
    return (avant ? '<small>' + echappe(avant) + '</small>' : '') + echappe(m[2]) + (apres ? sep + '<small>' + echappe(apres) + '</small>' : '');
  }

  /* 4. Date courte des pastilles, à l'heure de Paris, dans la langue de la page. */
  function datesCourtes() {
    var liste = document.querySelectorAll('[data-cm-date-courte]');
    if (!liste.length || !window.Intl || !Intl.DateTimeFormat) return;
    var langue = document.documentElement.getAttribute('lang') || 'fr';
    var fmt;
    /* lt et pt : mois en toutes lettres (« lapkričio 26 d. », « 26 de novembro »),
       la forme courte d'Intl y est numérique et illisible (b8, 29/10). */
    var moisLong = /^(lt|pt)(-|$)/i.test(langue);
    /* en : la page est en anglais britannique (« 22 November » dans les textes) ;
       Intl('en') donne l'ordre américain « Nov 22 », on force en-GB (« 22 Nov »)
       (relecture b8, 30/10). */
    if (/^en$/i.test(langue)) langue = 'en-GB';
    try {
      fmt = new Intl.DateTimeFormat(langue, { day: 'numeric', month: moisLong ? 'long' : 'short', timeZone: 'Europe/Paris' });
    } catch (e) {
      return;
    }
    chaque(liste, function (el) {
      /* midi : à l'abri de tout décalage de fuseau */
      var d = new Date(el.getAttribute('data-cm-date-courte') + 'T12:00:00+01:00');
      if (isNaN(d.getTime())) return;
      var txt = fmt.format(d);
      if (el.textContent !== txt) el.textContent = txt;
    });
  }

  function initOffre(haut) {
    var section = haut.closest('.shopify-section') || haut.parentNode;
    var bandeau = haut.querySelector('[data-cm-bandeau]');

    function majHauteur() {
      var h = section.getBoundingClientRect().height;
      document.documentElement.style.setProperty('--casemira-topbar-h', Math.max(0, Math.round(h)) + 'px');
    }

    function ecrire(el, valeur, html) {
      if (html) {
        if (el.innerHTML !== valeur) el.innerHTML = valeur;
      } else if (el.textContent !== valeur) {
        el.textContent = valeur;
      }
    }

    function majMontants() {
      var O = window.CM_OFFRE;
      if (O) {
        var affichables = O.montantsAffichables !== false;
        chaque(section.querySelectorAll('[data-cm-hors-euro]'), function (el) {
          el.classList.toggle('cm-hors-euro', !affichables);
        });
        if (affichables && typeof O.format === 'function') {
          /* 31/10 : hors euro, les équivalences arrondies (`*Aff`, « ≈ ») de
             casemira-offre.js ; en euro, les mêmes valeurs qu'avant. */
          var fm = typeof O.formatMontant === 'function' ? O.formatMontant : O.format;
          chaque(section.querySelectorAll('[data-cm-montant]'), function (el) {
            var c = (O.montantsAff || O.montants || [])[parseInt(el.getAttribute('data-cm-montant'), 10) - 1];
            if (c == null) return;
            var f = fm(c);
            if (el.hasAttribute('data-cm-devise-petite')) ecrire(el, deviseEnPetit(f), true);
            else ecrire(el, f);
          });
          chaque(section.querySelectorAll('[data-cm-seuil]'), function (el) {
            var c = (O.seuilsAff || O.seuils || [])[parseInt(el.getAttribute('data-cm-seuil'), 10) - 1];
            if (c != null) ecrire(el, O.format(c));
          });
          chaque(section.querySelectorAll('[data-cm-montant-max]'), function (el) {
            var mx = O.montantMaxAff || O.montantMax;
            if (mx) ecrire(el, fm(mx));
          });
        }
        chaque(section.querySelectorAll('[data-cm-pct]'), function (el) {
          if (O.pctMax != null) ecrire(el, String(O.pctMax));
        });
      }
      majHauteur();
    }

    if (bandeau) {
      bandeau.addEventListener('click', function () {
        if (window.CM_OFFRE_FENETRE) window.CM_OFFRE_FENETRE.ouvrir(bandeau);
      });
    }

    document.addEventListener('cm-offre-prete', majMontants);
    document.addEventListener('cm-offre-periode', majMontants);

    var prevu = 0;
    function plusTard() {
      if (prevu) return;
      prevu = requestAnimationFrame(function () {
        prevu = 0;
        majHauteur();
      });
    }
    if ('ResizeObserver' in window) {
      new ResizeObserver(plusTard).observe(haut);
    } else {
      window.addEventListener('resize', plusTard, { passive: true });
    }

    majMontants();
  }

  /* ==========================================================================
     HORS OFFRE (décembre, janvier) : les trois messages, comme avant.
     ========================================================================== */
  function initCasemiraTopbar() {
    var topbar = document.querySelector('.casemira-topbar');
    if (!topbar) return;

    var items = topbar.querySelectorAll('.casemira-topbar__item');
    if (items.length < 2) return;

    var speed = parseInt(topbar.dataset.rotationSpeed, 10) || 4500;
    var mobileMq = window.matchMedia('(max-width: 1023px)');
    var rotationInterval = null;
    var currentStep = 0;
    var isPaused = false;

    // Rotation pondérée : le -10% (index 1) apparaît 2× plus souvent
    // Cycle : -10% → Service Client → -10% → Satisfait ou remboursé
    var sequence = [1, 0, 1, 2];

    function showIndex(idx) {
      items.forEach(function (item, i) {
        item.classList.toggle('is-active', i === idx);
      });
    }

    function tick() {
      if (isPaused) return;
      currentStep = (currentStep + 1) % sequence.length;
      showIndex(sequence[currentStep]);
    }

    function startRotation() {
      stopRotation();
      /* CASEMIRA PERF (F1 bis) : le serveur rend deja l'element data-index="0"
         en is-active (sections/topbar.liquid). L'ancien code appelait
         showIndex(sequence[0]) = index 1 immediatement a l'init : le bandeau
         changeait de texte (« Service Client Francais » -> « -10% sur votre
         1ere commande ») dans la premiere seconde, a CHAQUE chargement.
         On se cale desormais sur l'element deja actif et on laisse passer un
         intervalle complet avant le premier changement. La ponderation du cycle
         est inchangee : la sequence [1, 0, 1, 2] est simplement parcourue a
         partir de la position de l'index 0.
         Repli : si aucun element n'est actif (retour depuis l'ordinateur, ou
         applyMq a retire is-active), on repart au debut de la sequence. */
      var activeIdx = -1;
      items.forEach(function (item, i) {
        if (item.classList.contains('is-active')) activeIdx = i;
      });
      var startStep = sequence.indexOf(activeIdx);
      if (startStep === -1) {
        startStep = 0;
        showIndex(sequence[0]);
      }
      currentStep = startStep;
      rotationInterval = setInterval(tick, speed);
    }

    function stopRotation() {
      if (rotationInterval) {
        clearInterval(rotationInterval);
        rotationInterval = null;
      }
    }

    function applyMq() {
      if (mobileMq.matches) {
        startRotation();
      } else {
        stopRotation();
        items.forEach(function (item) { item.classList.remove('is-active'); });
      }
    }

    // Pause au touch (laisse le temps de lire ou cliquer)
    topbar.addEventListener('touchstart', function () { isPaused = true; }, { passive: true });
    topbar.addEventListener('touchend', function () {
      setTimeout(function () { isPaused = false; }, 1500);
    }, { passive: true });

    // Pause si onglet non visible
    document.addEventListener('visibilitychange', function () {
      isPaused = document.hidden;
    });

    // Clic sur le CTA -10% → ouvrir la pop-up newsletter
    var ctaLinks = topbar.querySelectorAll('[data-open-newsletter-popup]');
    ctaLinks.forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        var modal = document.querySelector('subscription-popup[id^="SubscriptionModal"]');
        if (!modal) return;
        // Si déjà ouvert, ne rien faire
        if (modal.hasAttribute('active')) return;

        // Figer le scroll : `overflow` sur la RACINE, jamais `position: fixed`
        // sur `body` (correctif D13, même règle que le tiroir panier C4 et que
        // assets/casemira-popup.js).
        var scrollY = window.pageYOffset || document.documentElement.scrollTop;
        var sbw = window.innerWidth - document.documentElement.clientWidth;
        document.documentElement.style.setProperty('--scrollbar-width', sbw + 'px');

        // Ouvrir avec le même pattern que le script exit-intent
        var reduit = false;
        try { reduit = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (err) {}
        modal.removeAttribute('hidden');
        modal.setAttribute('open', '');
        if (reduit) {
          modal.setAttribute('active', '');
        } else {
          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              modal.setAttribute('active', '');
            });
          });
        }
        document.documentElement.classList.add('modal-show');

        // Fermeture : on laisse les handlers existants du popup gérer ça
        // Mais on ajoute un handler pour restaurer le scroll si besoin
        function restoreScroll() {
          if (Math.abs((window.pageYOffset || 0) - scrollY) > 1) window.scrollTo(0, scrollY);
        }

        var overlay = modal.querySelector('.fixed-overlay');
        var closeBtn = modal.querySelector('.drawer__close-btn');

        function closeFromTopbar() {
          modal.removeAttribute('active');
          document.documentElement.classList.remove('modal-show');
          restoreScroll();
          setTimeout(function () {
            modal.setAttribute('hidden', '');
            modal.removeAttribute('open');
          }, 400);
          // Cleanup
          if (overlay) overlay.removeEventListener('click', closeFromTopbar);
          if (closeBtn) closeBtn.removeEventListener('click', closeFromTopbar);
        }

        if (overlay) overlay.addEventListener('click', closeFromTopbar);
        if (closeBtn) closeBtn.addEventListener('click', closeFromTopbar);
      });
    });
    applyMq();

    if (mobileMq.addEventListener) {
      mobileMq.addEventListener('change', applyMq);
    } else if (mobileMq.addListener) {
      mobileMq.addListener(applyMq);
    }
  }

  function demarrer() {
    var haut = document.querySelector('[data-cm-haut]');
    datesCourtes();
    if (haut) {
      initOffre(haut);
      return;
    }
    initCasemiraTopbar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }
})();
